import React, { useState } from "react";
import { PfsFileGeometry } from "../../../schema/generated/schema";

import fileUtils, { ModelViewerFile } from "../../../utils/fileUtils";
import HoopsModal from "../../HoopsModal";
import { useConfig } from "./configContext";

type ModelViewerContextData = {
  openModelViewer: (file: ModelViewerFile) => void;
  closeModelViewer: () => void;
};

type ModelViewerProviderProps = {
  children: React.ReactElement;
};

type ModelViewerContextState = {
  streamcacheFileUrl: string | null;
  file: ModelViewerFile | null;
  fileGeometry?: PfsFileGeometry;
  is3DViewerModalOpen: boolean;
};

const ModelViewerContext = React.createContext<Partial<ModelViewerContextData>>(
  {}
);

export const ModelViewerProvider = ({
  children,
}: ModelViewerProviderProps): React.ReactElement => {
  const [modelViewerState, setModelViewerState] =
    useState<ModelViewerContextState>({
      streamcacheFileUrl: null,
      file: null,
      is3DViewerModalOpen: false,
    });
  const { origins } = useConfig();

  const toggleModelViewer = (file?: ModelViewerFile) => {
    if (file?.id) {
      fileUtils
        .getFileStreamcacheUrl(origins.partFilesService, file.id)
        .then(url => {
          setModelViewerState({
            streamcacheFileUrl: url,
            file,
            is3DViewerModalOpen: true,
          });
        })
        .catch(e => {
          console.error(e);
        });
    } else {
      setModelViewerState({
        streamcacheFileUrl: null,
        file: null,
        is3DViewerModalOpen: false,
      });
    }
  };

  const value = {
    openModelViewer: toggleModelViewer,
    closeModelViewer: () => toggleModelViewer(),
  };

  return (
    <ModelViewerContext.Provider value={value}>
      {children}
      <HoopsModal
        {...modelViewerState}
        toggle3DViewerModal={toggleModelViewer}
      />
    </ModelViewerContext.Provider>
  );
};

export default ModelViewerContext;
